import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import useCertification from './hooks/useCertification';
import SignUpContext from '../../context/SignUpContext';

function Certification() {
    const { t } = useTranslation('signUp');
    const {
        onChangeValue, inputValue, certValue,
        code, onChangeCode, requestSms, requestVerify,
    } = useCertification();
    const isEmail = useIsEmailSignIn();
    const { inputEmail } = useContext(SignUpContext);
    if (inputEmail) {
        return (
            <Container as='section' fullWidth spacing={3}>
                <Text size='title-lg' fontWeight='bold'>
                    {t('certification.title')}
                </Text>
                <TextField value={inputEmail} readOnly
                    aria-label={t('certification.emailPlaceholder')}
                    inputMode='email' />
            </Container>
        );
    }
    const labelKey = isEmail
        ? 'certification.emailLabel' : 'certification.phoneLabel';
    const placeholderKey = isEmail
        ? 'certification.emailPlaceholder' : 'certification.phonePlaceholder';
    return (
        <Container as='section'
            fullWidth
            spacing={3} >
            <Column fullWidth spacing={4}>
                {/* 전화번호 */}
                <Column fullWidth spacing={1}>
                    <Label>{t(labelKey)}</Label>
                    <Row fullWidth spacing={2}>
                        <TextField placeholder={t(placeholderKey)}
                            value={inputValue}
                            onChange={onChangeValue}
                            maxLength={isEmail ? 100 : 13}
                            inputMode={isEmail ? 'email' : 'numeric'} />
                        <ActionButton onClick={requestSms}
                            variant='outlined'
                            size='small'
                            type='button' >
                            {certValue ? t('certification.resendCode') : t('certification.requestCode')}
                        </ActionButton>
                    </Row>
                </Column>
                {/*  인증번호 */}
                <Column fullWidth spacing={1}>
                    <Label>{t('certification.codeLabel')}</Label>
                    <Row fullWidth spacing={2}>
                        <TextField placeholder={t('certification.codePlaceholder')}
                            maxLength={6}
                            value={code}
                            onChange={onChangeCode}
                            inputMode='numeric' />
                        <ActionButton onClick={requestVerify}
                            variant='outlined'
                            size='small'
                            type='button' >
                            {t('certification.verifyCode')}
                        </ActionButton>
                    </Row>
                </Column>
            </Column>
            {/* 정보 제공 */}
            <Row spacing={1.5}>
                <Text color={colors.textThird} size='body-long' >
                    <Trans ns='signUp'
                        i18nKey='certification.privacyConsignee'
                        components={{ b: <b/> }} />
                </Text>
                <Separator/>
                <Text color={colors.textThird} size='body-long' >
                    <Trans ns='signUp'
                        i18nKey='certification.privacyPurpose'
                        components={{ b: <b/> }} />
                </Text>
            </Row>
        </Container>
    );
}

function Label({ children }: { children: string }) {
    return (
        <Text fontWeight='medium' color={colors.textSecondary}>
            {children}
        </Text>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-4);
`;

const Separator = styled.div`
    background-color: var(--color-gray5);
    height: 8px;
    width: 1px;
`;

const ActionButton = styled(Button)`
    border-radius: var(--radius-sm)
`;

export default Certification;
